import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { useState, useCallback } from 'react';
import { getInitialCollaborationSidebarState, mergeCollaborationSidebarState } from '../utils/collaborationSidebarState';
import ControlledCollaborationSidebarProvider from './ControlledCollaborationSidebarProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export default function CollaborationSidebarProvider(_ref) {
  let {
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [collaborationSidebarState, setCollaborationSidebarState] = useState(() => getInitialCollaborationSidebarState());
  const onUpdateCollaborationSidebarState = useCallback(updates => {
    setCollaborationSidebarState(state => mergeCollaborationSidebarState(state, updates));
  }, []);
  return /*#__PURE__*/_jsx(ControlledCollaborationSidebarProvider, Object.assign({}, props, {
    collaborationSidebarState: collaborationSidebarState,
    onUpdateCollaborationSidebarState: onUpdateCollaborationSidebarState,
    children: children
  }));
}